import primitives from '@veneer/primitives';
import styled from 'styled-components';

export const Container = styled.p`
  letter-spacing: 0px;
  font-size: ${primitives.typography.size4};
  margin: ${primitives.layout.size0}px;
`;
